import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { ComponentPropsWithoutRef } from "react";

import { ImageModalComponent } from "./ImageModalComponent";

const CompassModal = ModalManager.create(
  (
    props: Omit<
      ComponentPropsWithoutRef<typeof ImageModalComponent>,
      "open" | "onOpenChange"
    >,
  ) => {
    const modal = useModal();

    return (
      <ImageModalComponent
        {...props}
        open={modal.visible}
        onOpenChange={open => {
          if (!open) {
            modal.remove();
          }
        }}
      />
    );
  },
);

export const useImagePickerModal = () => useModal(CompassModal);
